import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToHash handles scrolling to an anchor (e.g., #contact) 
 * when the URL hash changes or when navigating to a new page with a hash.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Small timeout to ensure the element is rendered
      const timeoutId = setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
      return () => clearTimeout(timeoutId);
    } else {
      // Regular navigation without hash: scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
